module.exports = __webpack_public_path__ + "static/boat-245c6377ddbaced1c06eec29ed19adf0.png";